import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertVendorShare from "../../../components/vendorShareComponent/insertVendorShare";
import { translate } from "react-i18next";
class Vendor extends Component {

  
  constructor(props) {
    super(props);
    this.state = {
      title: localStorage.getItem('customerNumber') != 1158 ? "add_vendor_title" : "add_title",
      editData: {},
    };
  }

  
  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: localStorage.getItem('customerNumber') != 1158 ? "edit_vendor_title" : "edit_title",
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/vendor-share");
    // this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar
          Title={this.props.t(this.state.title) || this.state.title}
          LinkName="/vendor-share"
        />
        <div className="m-2">
          <InsertVendorShare
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("vendor_share")(Vendor);
